<template>
  <transition
    appear
    :css="false"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div v-if="visible" ref="collapse" class="collapse">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: [String, Number],
      default: 0,
    },
    duration: {
      type: [String, Number],
      default: 0.5,
    },
  },
  watch: {
    visible() {
      this.$nextTick(() => {
        this.updateHeight();
      });
    },
  },
  methods: {
    updateHeight() {
      this.$nextTick(() => {
        const el = this.$refs.collapse;
        if (el) {
          if (this.visible) {
            el.style.height = "auto";
            const height = el.scrollHeight;
            el.style.height = "0px";
            requestAnimationFrame(() => {
              el.style.height = `${height}px`;
            });
          } else {
            el.style.height = `${el.scrollHeight}px`;
            requestAnimationFrame(() => {
              el.style.height = "0px";
            });
          }
        }
      });
    },
    beforeEnter(el) {
      el.style.height = "0px";
      el.style.transitionProperty = "height";
      el.style.transitionDuration = `${this.duration}s`;
      el.style.transitionDelay = `${this.delay}s`;
    },
    enter(el, done) {
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.height = `${el.scrollHeight}px`;
      });
      el.addEventListener("transitionend", function handler(event) {
        if (event.propertyName === "height") {
          done();
          el.removeEventListener("transitionend", handler);
        }
      });
    },
    afterEnter(el) {
      el.style.overflow = "visible";
      el.style.height = "auto";
    },
    beforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.transitionProperty = "height";
      el.style.transitionDuration = `${this.duration}s`;
      el.style.transitionDelay = `${this.delay}s`;
    },
    leave(el, done) {
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.height = "0px";
      });
      el.addEventListener("transitionend", done, { once: true });
    },
    afterLeave(el) {
      el.style.overflow = "hidden";
    },
  },
};
</script>

<style scoped>
.collapse {
  overflow: hidden;
  transition: height 0.5s ease;
}
</style>
